import {
  cancelMassiveDependentsExclusion,
  finishMassiveDependentsExclusion,
  getMassiveDependentsExclusionsOfTicket,
  getMassiveDependentsExclusionDetail,
  ticketGroupService
} from '../../../../network';

import {
  FETCH_MASSIVE_DEPENDENTS_EXCLUSION_URL,
  SET_MASSIVE_DEPENDENTS_EXCLUSION_URL,
  GET_MASSIVE_DEPENDENTS_EXCLUSION_URL,
  POST_MASSIVE_DEPENDENTS_EXCLUSION,
  FETCH_MASSIVE_DEPENDENTS_EXCLUSION_OF_TICKET,
  POST_MASSIVE_CANCEL_DEPENDENTS_EXCLUSION,
  POST_MASSIVE_FINISH_DEPENDENTS_EXCLUSION,
  FETCH_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL,
  SET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL,
  GET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL,
  FETCH_MASSIVE_DEPENDENTS_EXCLUSION_FILE,
  SET_MASSIVE_DEPENDENTS_EXCLUSION_FILE,
  GET_MASSIVE_DEPENDENTS_EXCLUSION_FILE,
  FETCH_TICKET_GROUP_OPTIONAL_FILES,
  SET_TICKET_GROUP_OPTIONAL_FILES,
  GET_TICKET_GROUP_OPTIONAL_FILES,
  MASSIVE_DEPENDANTS_EXCLUSION_PRE_SUCCESS,
  MASSIVE_DEPENDANTS_EXCLUSION_SUCCESS,
  MASSIVE_DEPENDANTS_EXCLUSION_PRE_CANCEL,
  MASSIVE_DEPENDANTS_EXCLUSION_CANCEL
} from './types';

const store = {};
const getDefaultState = () => ({
  dependentsExclusionUrl: '',
  ticketDetail: {},
  ticketFile: {},
  optionalFiles: {}
});

store.state = getDefaultState();

store.getters = {
  [GET_MASSIVE_DEPENDENTS_EXCLUSION_URL](state) {
    return state.dependentsExclusionUrl;
  },
  [GET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL](state) {
    return state.ticketDetail;
  },
  [GET_MASSIVE_DEPENDENTS_EXCLUSION_FILE](state) {
    return state.ticketFile;
  },
  [GET_TICKET_GROUP_OPTIONAL_FILES](state) {
    return state.optionalFiles;
  }
};

store.mutations = {
  [SET_MASSIVE_DEPENDENTS_EXCLUSION_URL](state, payload) {
    state.dependentsExclusionUrl = payload;
  },
  [SET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL](state, payload) {
    state.ticketDetail = payload;
  },
  [SET_MASSIVE_DEPENDENTS_EXCLUSION_FILE](state, payload) {
    state.ticketFile = payload.map((a) => {
      return {
        id: a.id,
        key: a.id,
        name: a.name,
        route: a.presignedFile,
        ver: 'Ver más'
      };
    });
  },
  [SET_TICKET_GROUP_OPTIONAL_FILES](state, payload) {
    state.optionalFiles = payload;
  }
};

store.actions = {
  async [FETCH_MASSIVE_DEPENDENTS_EXCLUSION_URL]({ commit }, payload) {
    const response = ticketGroupService.getMassiveDependentsExclusionFormatUrl(
      payload.companyId,
      payload.insuranceCompanyId
    );
    commit(SET_MASSIVE_DEPENDENTS_EXCLUSION_URL, response);
    return response;
  },
  async [FETCH_MASSIVE_DEPENDENTS_EXCLUSION_OF_TICKET](_, ticketGroupId) {
    const response =
      await getMassiveDependentsExclusionsOfTicket(ticketGroupId);
    return response.data;
  },
  async [POST_MASSIVE_DEPENDENTS_EXCLUSION](_, payload) {
    return ticketGroupService.createMassiveDependentsExclusion(payload);
  },
  async [POST_MASSIVE_CANCEL_DEPENDENTS_EXCLUSION](_, ticketGroupId) {
    const response = await cancelMassiveDependentsExclusion(ticketGroupId);
    return response.data;
  },
  async [POST_MASSIVE_FINISH_DEPENDENTS_EXCLUSION](_, ticketGroupId) {
    const response = await finishMassiveDependentsExclusion(ticketGroupId);
    return response.data;
  },
  async [FETCH_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL]({ commit }, ticketId) {
    return new Promise((resolve, reject) => {
      getMassiveDependentsExclusionDetail(ticketId).then(
        (resp) => {
          commit(SET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL, resp.data);
          resolve(resp);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  async [FETCH_MASSIVE_DEPENDENTS_EXCLUSION_FILE]({ commit }, ticketId) {
    const response =
      await ticketGroupService.getMassiveDependentsExclusionFiles(ticketId);
    commit(SET_MASSIVE_DEPENDENTS_EXCLUSION_FILE, response);
  },
  async [FETCH_TICKET_GROUP_OPTIONAL_FILES]({ commit }, ticketGroupId) {
    try {
      const response =
        await ticketGroupService.getTicketGroupOptionalFiles(ticketGroupId);
      if (response && (response.status === 201 || response.status === 200)) {
        commit(SET_TICKET_GROUP_OPTIONAL_FILES, response.data);
      }
    } catch (error) {
      console.error(
        'Error al obtener los archivos opcionales del ticket. FETCH_OPTIONAL_FILES_TICKET_GROUP:',
        error.response.data.message
      );
      throw error.response.data.message;
    }
  },
  async [MASSIVE_DEPENDANTS_EXCLUSION_PRE_SUCCESS](_, ticketGroupId) {
    return ticketGroupService.preSuccessMassiveDependentsExclusion(
      ticketGroupId
    );
  },
  async [MASSIVE_DEPENDANTS_EXCLUSION_SUCCESS](_, { ticketGroupId, payload }) {
    return ticketGroupService.successMassiveDependentsExclusion(
      ticketGroupId,
      payload
    );
  },
  async [MASSIVE_DEPENDANTS_EXCLUSION_PRE_CANCEL](_, ticketGroupId) {
    return ticketGroupService.preCancelMassiveDependentsExclusion(
      ticketGroupId
    );
  },
  async [MASSIVE_DEPENDANTS_EXCLUSION_CANCEL](_, { ticketGroupId, payload }) {
    return ticketGroupService.cancelMassiveDependentsExclusion(
      ticketGroupId,
      payload
    );
  }
};

export default store;
